import { AWS_CLOUD_FRONT_ENDPOINT } from '@gymaholic/packages'

/**
 * The cdn's root url.
 * @type {string}
 */
const AWS_CLOUD_FRONT_TRAINING_URL = AWS_CLOUD_FRONT_ENDPOINT

export {
  AWS_CLOUD_FRONT_TRAINING_URL
}
